/**
* Created by superman on 17/2/16.
* http配置
*/

import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import Qs from 'qs'


import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import conf from '../../static/config/index.json'
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)

axios.defaults.timeout = 20000
axios.defaults.baseURL = '/'


let type = conf.systemType

axios.interceptors.request.use(
config => {
config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
if (type === 'yingxin') {
config.headers['systemType'] = 'yingxin_student_app'
} else if (type === 'yingxin-manage') {
config.headers['systemType'] = 'yingxin_teacher_app'
} else if (type === 'pay') {
config.headers['Authorization'] = 'Basic Y2hhcmdlOmNoYXJnZV9zZWNyZXQ='
}
let url = config.url.split('/')
if (type === 'pay') {

config.headers['synjones-auth'] = 'bearer ' + store.state.token
if (url[url.length - 1] === 'token' || url[url.length - 1] === 'pay') {
config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
}
} else if (type === 'yingxin' || type === 'yingxin-manage') {
config.headers['access_token'] = store.state.token
}






return config
},
err => {
Vue.$vux.loading.hide()
return Promise.reject(err)
}
)

axios.interceptors.response.use(
response => {

if (response.data.code || response.data.state) {
switch (response.data.code || response.data.state) {
case 200:

let current = new Date().getTime()

if (sessionStorage.getItem('refreshObj') && type === 'pay') {
let login = JSON.parse(sessionStorage.getItem('refreshObj')).login_time
let expire = JSON.parse(sessionStorage.getItem('refreshObj')).expires_in
let time = parseInt((current - login) / 1000)

let params = {
'grant_type': 'refresh_token',
'scope': 'all',
'refresh_token': JSON.parse(sessionStorage.getItem('refreshObj')).refresh_token,
'logintype': JSON.parse(sessionStorage.getItem('refreshObj')).logintype
}
if (time > (expire - 5 * 60)) {

axios.post(conf.loginApi + '/blade-auth/oauth/token', Qs.stringify(params))
.then(r => {
let data = r.data

let newObj = {
'expires_in': data.expires_in,
'refresh_token': data.refresh_token,
'login_time': new Date().getTime(),
'logintype': JSON.parse(sessionStorage.getItem('refreshObj')).logintype
}

store.dispatch('LoginAction', data.access_token)

sessionStorage.setItem('refreshObj', JSON.stringify(newObj))

})
.catch(err => {
console.log(err)
})
}
}
break
case 401:


if (type === 'pay') {




}
store.dispatch('LogoutAction')
break
case 500:
Vue.$vux.toast.text(response.data.msg, 'middle')
}
}
return response
},
error => {
Vue.$vux.loading.hide()
console.log(error)
}
)

export default axios



// WEBPACK FOOTER //
// ./src/common/http.js